import { useClusterDashboardTimeRange } from './useClusterDashboardTimeRange';

export const useClusterDashboardOverviewQueryArgs = () => {
  const { overviewQueryArgs, range, timeZone } = useClusterDashboardTimeRange();

  return {
    ...overviewQueryArgs,
    range,
    timeZone,
  };
};
